// extracted by mini-css-extract-plugin
export default {"text":"ListItemText_text__efuW1","dense":"ListItemText_dense__yFVlQ"};